import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import cashier from "../../front_assets/user_images/dummy.jpg";
import cash from "../../front_assets/Payment_images/cash.png";
import bkash from "../../front_assets/Payment_images/bkash.png";
import nagad from "../../front_assets/Payment_images/nagad.png";
import rocket from "../../front_assets/Payment_images/rocket.png";
import card from "../../front_assets/Payment_images/card.png";
import { useReactToPrint } from "react-to-print";
import { Modal } from "./Modal";
import Invoice from "./Invoice";
import { propsContext } from "../dashboard";
import AuthUser from "../AuthUser";
import "../../CSS/Invoice.css";
import http from "../../http";
import { memberContext } from "../../navbar/auth";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import SalesReturnModal from "../SalesComponent/SalesReturnModal";
import moment, { max } from "moment";
import { FaAngleDown } from "react-icons/fa";
const RightSidebar = ({ pImage, setPImage, setSearchMedicine }) => {
  const [error, setError] = useState("");

  const { user } = AuthUser();
  // Context Api Start
  const {
    setPaymentMethod,
    paymentMethod,
    invoiceReload,
    setInvoiceReload,
    setCart,
    cart,
    allSubTotal,
    allSubTotalWithoutDiscount,
    invoice,
    setInvoiceId,
    invoiceId,
    isSpecialDiscount,
    setSpecialDiscount,
    specialDiscount,
    returnAmount,
    setReturnAmount,
    setUpdateTrack,
    updateTrack,
    paymentStatus,
    selectedInvoice,
    setSelectedInvoice,
    setAutoReloadInvoice,
    autoReloadInvoice,
    prescriptionImage,
    setPrescriptionImage,
    paidAmount,
    setPaidAmount,
    setPaymentStatus,
  } = useContext(propsContext);



  const { currentMember, setCurrentMember } = useContext(memberContext);


  const maximumDiscountableAmount = useMemo(() => {
    return cart.reduce((max, item) => {
      const itemDiscountAmount = parseFloat(item?.drug?.price) ?? 0;
      const isDiscountable = item.drug?.is_applied_discount ?? true;
      const qty = parseInt(item.pcs) || 0;
      return max + (isDiscountable ? itemDiscountAmount * qty : 0);
    }, 0);
  }, [cart.length, cart]);

  const [cardType, setCardType] = useState("Visa Card");
  const [digitalType, setDigitalType] = useState("");
  // Context Api end
  const handleChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  const handleCartChange = (event) => {
    setCardType(event.target.value);
  };
  const handleDigitalChange = (event) => {
    setDigitalType(event.target.value);
  };

  const [grandTotal, setGrandTotal] = useState(0);
  const [specialDiscountType, setSpecialDiscountType] = useState("Fixed");
  const [specialDiscountPercent, setSpecialDiscountPercent] = useState("");
  const [invoiceAllTotal, setInvoiceAllTotal] = useState(0);

  // Sales side Discount

  const [modalIsOpen, setIsOpen] = useState(false);

  const partialInvoice =
    selectedInvoice?.paid_amount > 0 &&
      selectedInvoice?.due_amount > 0 &&
      selectedInvoice?.payment_status === "Partially Paid"
      ? true
      : false;

  const [currentInvoiceId, setCurrentInvoiceId] = useState("");
  const [isPreview, setIsPreview] = useState(false);

  useEffect(() => {
    if (
      selectedInvoice?.paid_amount > 0 &&
      selectedInvoice?.due_amount > 0 &&
      selectedInvoice?.payment_status === "Partially Paid"
    ) {
      setGrandTotal(parseFloat(selectedInvoice?.due_amount));
      setInvoiceAllTotal(parseFloat(selectedInvoice?.sub_total));
    } else {
      setInvoiceAllTotal(parseFloat(allSubTotalWithoutDiscount).toFixed(2));
      setGrandTotal(parseFloat(invoiceAllTotal - specialDiscount).toFixed(2));
      setCurrentInvoiceId({ ...currentMember });
    }
  }, [
    allSubTotal,
    specialDiscount,
    allSubTotalWithoutDiscount,
    paymentMethod,
    modalIsOpen,
    cart,
  ]);

  // For payment calculation
  const handlePay = (e) => {
    if (paymentMethod === "Credit Payment") {
      setPaidAmountError(false);
      setPaidAmount();
    } else {
      const val = parseFloat(e.target.value);
      if (val < 0) {
        setPaidAmountError(true);
        toast.error("Paid amount can't be negative");
        return;
      }
      setPaidAmountError(false);
      setPaidAmount(val);
    }
  };

  useEffect(() => {
    if (paidAmount > grandTotal) {
      setReturnAmount(paidAmount - grandTotal);
    } else {
      setReturnAmount(0);
    }
  }, [grandTotal, paidAmount]);

  // Clear information
  const clearInformation = (info) => {
    setCart([]);
    setInvoiceReload(!invoiceReload);
    setIsOpen(false);
    // setCurrentMember({});
    setInvoiceId();
    setSpecialDiscount(0);
    setReturnAmount(0);
    setPaymentMethod("Cash");
    setPaymentStatus("Default");
    setPaidAmount();
    setPrescriptionImage("");
    setPImage("");
    setSearchMedicine("");
    setSelectedInvoice({});
    setSpecialDiscount("0");
    pImage.value = "";
    Swal.fire({
      position: "top-center",
      icon: "success",
      title: `${info} !`,
      text: "Your data has been saved",
      timer: 1000,
    });
  };
  const [digitalNumber, setDigitalNumber] = useState("");
  const [discountError, setDiscountError] = useState(false);
  const [paidAmountError, setPaidAmountError] = useState(false);
  const handleDigitalNumber = (e) => {
    let { value } = e.target;
    // value = Math.max(parseFloat(min), Math.min(parseFloat(max), parseFloat(value)));
    setDigitalNumber(value);
  };
  // Special percentage calculation
  const handleSpecialPercentage = (e) => {
    if (specialDiscountType === "Fixed" && e.target.value.length > 0) {
      let { value } = e.target;
      if (parseFloat(value) > parseFloat(maximumDiscountableAmount)) {
        setDiscountError(true);
        toast.error("Discount can't be more than maximum discountable amount");
        setSpecialDiscount(0);
        setSpecialDiscountPercent("");
        return;
      }
      setDiscountError(false);
      setSpecialDiscount(value);
      // Always keep specialDiscountPercent in sync as the equivalent %
      const equivPercent = maximumDiscountableAmount > 0
        ? ((parseFloat(value) / parseFloat(maximumDiscountableAmount)) * 100).toFixed(2)
        : "";
      setSpecialDiscountPercent(equivPercent);
      if (paidAmount > 0) {
        setPaidAmount(parseFloat(invoiceAllTotal - value).toFixed(2));
      }
    } else if (
      specialDiscountType === "Percentage" &&
      e.target.value.length > 0
    ) {
      let { value } = e.target;
      const discountAmount =
        (parseFloat(maximumDiscountableAmount) * parseFloat(value)) / 100;
      setSpecialDiscount(discountAmount.toFixed(2));
      setSpecialDiscountPercent(value);
      if (value > 100 || discountAmount > maximumDiscountableAmount) {
        setDiscountError(true);
        toast.error(
          "Percentage can't be more than 100 or maximum discountable amount",
        );
        setSpecialDiscount(0);
        setSpecialDiscountPercent("");
        return;
      } else {
        setDiscountError(false);
      }
      if (paidAmount > 0) {
        setPaidAmount(parseFloat(invoiceAllTotal - discountAmount).toFixed(2));
      }
    } else {
      setDiscountError(false);
      setSpecialDiscount(0);
      setSpecialDiscountPercent("");
      if (paidAmount > 0) {
        setPaidAmount(parseFloat(invoiceAllTotal).toFixed(2));
      }
    }
  };
  const [loading, setLoading] = useState(false);
  const isSubmitting = useRef(false);

  // print invoice
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      clearInformation("Invoice Create");
    },
  });
  const handlePrintPreview = useReactToPrint({
    content: () => componentRef.current,
  });

  // Create New Invoice
  const handleInvoiceGenerate = () => {


    const newCart = cart
      .filter((c) => parseInt(c.pcs) > 0)
      .map((item) => ({
        ...item,
        item_discount_percentage: parseFloat(item.drug?.is_applied_discount === true ? specialDiscountPercent || 0 : 0).toFixed(2),
      }));
    const memberId = currentMember.id ? currentMember.id : "";

    const formData = new FormData();

    formData.append("invoice_no", invoice);
    formData.append("member_id", memberId);

    formData.append("sub_total", invoiceAllTotal);
    formData.append("vat_tax_amount", 0);
    formData.append("payment_status", "Unpaid");

    formData.append("grand_total", invoiceAllTotal);
    formData.append(
      "discount_type",
      paymentMethod === "Digital Payment"
        ? `${paymentMethod?.charAt(0)?.toUpperCase()} -  
        ${digitalType?.charAt(0)?.toUpperCase()} : ${digitalNumber} `
        : paymentMethod === "Card"
          ? `${paymentMethod?.charAt(0)?.toUpperCase()} -
         ${cardType?.charAt(0)?.toUpperCase()} : : ${digitalNumber}`
          : paymentMethod,
    );
    formData.append("discount_amount", 0);

    formData.append("special_discount", specialDiscount);
    formData.append("paid_amount", 0);
    formData.append("return_amount", returnAmount);

    formData.append("prescription_image", prescriptionImage);
    formData.append("invoice_from", "web");
    formData.append("created_by", user?.name ? user?.name : "");
    formData.append("user_id", user?.id ? user?.id : "");


    formData.append("cart", JSON.stringify(newCart));

    http.post("invoice", formData).then((res) => {
      setAutoReloadInvoice(!autoReloadInvoice);
      if (res.data.status === 200) {
        handlePrint();
      } else {
        // console.log("res.data.errors",res.data.errors);
        setError(res.data.errors);
      }
    });
  };

  const handleUpdate = () => {
    if (discountError || paidAmountError) {
      toast.error("Please fix the errors before proceeding");
      return;
    }
    if (isSubmitting.current) {
      toast.info("Payment is processing, please wait");
      return;
    }
    isSubmitting.current = true;
    setUpdateTrack(!updateTrack);
    setLoading(true);

    const id = invoiceId;
    const newCart = cart
      .filter((c) => parseInt(c.pcs) > 0)
      .map((item) => ({
        ...item,
        item_discount_percentage: parseFloat(item.drug?.is_applied_discount === true ? specialDiscountPercent || 0 : 0).toFixed(2),
      }));

    const memberId = currentMember.id ? currentMember.id : "";

    if (id) {
      const formData = new FormData();
      formData.append("invoice_no", invoice);
      // formData.append('member_id', memberId)

      formData.append("sub_total", invoiceAllTotal);
      formData.append("vat_tax_amount", 0);
      formData.append(
        "payment_status",
        paymentMethod === "Credit Payment"
          ? "Unpaid"
          : paidAmount < grandTotal
            ? "Partially Paid"
            : "Paid",
      );
      formData.append(
        "due_amount",
        paidAmount > 0
          ? paidAmount >= grandTotal
            ? 0
            : grandTotal - paidAmount
          : selectedInvoice?.due_amount,
      );
      formData.append(
        "delete_status",
        paymentMethod === "Credit Payment"
          ? "null"
          : moment().format("YYYY-MM-DD"),
      );

      formData.append("special_discount", specialDiscount);
      formData.append(
        "paid_amount",
        partialInvoice
          ? parseFloat(paidAmount) + parseFloat(selectedInvoice?.paid_amount)
          : paidAmount,
      );
      formData.append("return_amount", returnAmount);

      formData.append("grand_total", invoiceAllTotal);
      formData.append(
        "discount_type",
        paymentMethod === "Digital Payment"
          ? `${paymentMethod?.charAt(0)?.toUpperCase()} -  
        ${digitalType?.charAt(0)?.toUpperCase()} : ${digitalNumber} `
          : paymentMethod === "Card"
            ? `${paymentMethod?.charAt(0)?.toUpperCase()} -
         ${cardType?.charAt(0)?.toUpperCase()} : : ${digitalNumber}`
            : paymentMethod,
      );
      formData.append("discount_amount", 0);

      formData.append("prescription_image", prescriptionImage);
      formData.append("invoice_from", "web");
      formData.append("cart", JSON.stringify(newCart));
      formData.append("updated_by", user?.name ? user?.name : "");
      formData.append("user_id", user?.id ? user?.id : "");


      http
        .post(`invoice/update/${id}`, formData)
        .then((res) => {
          if (res.data.status === 200) {
            setIsOpen(false);
            http
              .post(`stock-out-multiple`, {
                invoice_id: id,
                invoice_no: invoice,
                arrData: JSON.stringify(newCart),
              })
              .then((res) => {
                console.log(res, "stock-out-multiple");
              });

            // Swal.fire({
            //     position: 'top-center',
            //     icon: 'success',
            //     title: "Payment Done",
            //     timer: 1000
            // })
            clearInformation("Payment Done");
          } else {
            setError(res.data.errors);
          }
        })
        .catch((err) => {
          console.log(err, "invoice update error");
        })
        .finally(() => {
          setLoading(false);
          isSubmitting.current = false;
        });
    } else {
      const formData = new FormData();

      // formData.append('invoice_no', invoice)
      formData.append("member_id", memberId);

      formData.append("sub_total", invoiceAllTotal);
      formData.append("vat_tax_amount", 0);
      formData.append(
        "payment_status",
        paymentMethod === "Credit Payment"
          ? "Unpaid"
          : paidAmount < grandTotal
            ? "Partially Paid"
            : "Paid",
      );
      formData.append(
        "due_amount",
        paymentMethod === "Credit Payment"
          ? grandTotal
          : paidAmount >= grandTotal
            ? 0
            : grandTotal - paidAmount,
      );
      formData.append(
        "delete_status",
        paymentMethod === "Credit Payment"
          ? "null"
          : moment().format("YYYY-MM-DD"),
      );

      formData.append("grand_total", invoiceAllTotal);
      formData.append(
        "discount_type",
        paymentMethod === "Digital Payment"
          ? `${paymentMethod?.charAt(0)?.toUpperCase()}-${digitalType?.charAt(0)?.toUpperCase()} : ${digitalNumber} `
          : paymentMethod === "Card"
            ? `${paymentMethod?.charAt(0)?.toUpperCase()} - ${cardType?.charAt(0)?.toUpperCase()}:${digitalNumber}`
            : paymentMethod,
      );
      formData.append("discount_amount", 0);

      formData.append("special_discount", specialDiscount);
      formData.append("paid_amount", paidAmount || 0);
      formData.append("return_amount", returnAmount);

      formData.append("prescription_image", prescriptionImage);
      formData.append("invoice_from", "web");
      formData.append("created_by", user?.name ? user?.name : "");
      formData.append("cart", JSON.stringify(newCart));
      formData.append("user_id", user?.id ? user?.id : "");

      http
        .post("invoice", formData)
        .then((res) => {
          setAutoReloadInvoice(!autoReloadInvoice);
          if (res.data.status === 200) {
            setIsOpen(false);
            http
              .post(`stock-out-multiple`, {
                invoice_id: res.data.invoice.id,
                invoice_no: invoice,
                arrData: JSON.stringify(newCart),
              })
              .then((res) => {
                console.log(res, "stock-out-multiple");
              });

            handlePrint();
            //   setCurrentMember({});
          } else {
            // console.log("res.data.errors",res.data.errors);
            setError(res.data.errors);
          }
        })
        .catch((err) => {
          console.log(err, "invoice error");
        })
        .finally(() => {
          setLoading(false);
          isSubmitting.current = false;
        });
    }
  };

  // Modal close handler
  const closePaymentModal = () => {
    setIsOpen(false);
    setPaidAmount();
    setPaymentMethod("Cash");
    setDiscountError(false);
    setPaidAmountError(false);
  };



  return (
    <div className=" mt-2">
      {(selectedInvoice.fully_return == null ||
        selectedInvoice.fully_return === "null") && (
          <>
            {cart.length > 0 && (
              <div className="d-flex justify-content-end ">
                <span className="cart-sub-total me-md-2 me-lg-4 mt-2 fw-bold fs-5">
                  {" "}
                  Sub Total : {Number(allSubTotal).toFixed(2)}
                </span>

                {invoiceId ? (
                  user.user_type === "cashier" &&
                    (paymentStatus === "Unpaid" ||
                      paymentStatus === "Partially Paid") &&
                    allSubTotalWithoutDiscount > 0 ? (
                    <>
                      <button
                        style={{ backgroundColor: "#69B128", color: "white" }}
                        onClick={() => {
                          setIsOpen(true);
                          setPaidAmount();
                          setPaymentMethod("Cash");
                        }}
                        className="btn btn-sm mt-2 me-lg-2 px-4 fw-bold"
                      >
                        Pay Now
                      </button>
                      {(paymentMethod === "Credit Payment" ||
                        paymentStatus === "Partially Paid") && (
                          <SalesReturnModal
                            clearInformation={clearInformation}
                            invoiceId={invoiceId}
                          />
                        )}
                    </>
                  ) : paymentStatus === "Paid" ? (
                    <>
                      <SalesReturnModal
                        clearInformation={clearInformation}
                        invoiceId={invoiceId}
                      />
                    </>
                  ) : (
                    <button
                      style={{ backgroundColor: "#69B128", color: "white" }}
                      onClick={() => {
                        setIsOpen(true);
                        setPaidAmount();
                      }}
                      className="btn btn-sm mt-2 me-lg-2 px-4 fw-bold"
                    >
                      Pay Now
                    </button>
                  )
                ) : user.user_type === "cashier" &&
                  (paymentStatus === "Unpaid" || paymentStatus === "Default") &&
                  allSubTotalWithoutDiscount > 0 ? (
                  <button
                    style={{ backgroundColor: "#69B128", color: "white" }}
                    onClick={() => {
                      setIsOpen(true);
                      setPaidAmount();
                    }}
                    className="btn btn-sm mt-2 me-lg-2 px-4 fw-bold"
                  >
                    Pay Now
                  </button>
                ) : (
                  Number(allSubTotal) > 0 && (
                    <button
                      style={{ backgroundColor: "#69B128", color: "white" }}
                      onClick={() => {
                        handleInvoiceGenerate();
                      }}
                      className="btn btn-sm mt-2 me-lg-2 px-4 fw-bold"
                    >
                      Save{" "}
                    </button>
                  )
                )}
              </div>
            )}
          </>
        )}

      <Modal isOpen={modalIsOpen} onClose={closePaymentModal} size="sm">
        <Modal.Header onClose={closePaymentModal}>
          <div className="d-flex align-items-center gap-3">
            <div className="text-center right-sidebar-cashier-img">
              {user?.photo ? (
                <img
                  src={user.photo}
                  alt=""
                  style={{ height: "35px", borderRadius: "50%" }}
                />
              ) : (
                <img
                  src={cashier}
                  alt=""
                  style={{ height: "35px", borderRadius: "50%" }}
                />
              )}
            </div>
            <div>
              <Modal.Title>Payment — {invoice}</Modal.Title>
              <small className="text-muted" style={{ fontSize: "11px" }}>
                {user.name} ({user.user_type}) • Counter 1
              </small>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="pos-payment-method-container">
            <h6 className="pos-right-heading mb-2 fw-bold">Payment Method</h6>
            {/* Cash payment  */}
            <div className="d-flex justify-content-between border rounded p-1 align-items-center mb-2">
              <div className="form-check">
                <input
                  value="Cash"
                  checked={paymentMethod === "Cash"}
                  onChange={handleChange}
                  defaultChecked={true}
                  className="form-check-input"
                  type="radio"
                  name="paymentMethod"
                  id="flexRadioDefault1"
                />
                <label className="form-check-label" for="flexRadioDefault1">
                  Cash
                </label>
              </div>
              <div className="d-flex">
                <img src={cash} alt="" className="payment-method-img" />
              </div>
            </div>

            {/* Card payment  */}
            <div className="border rounded p-1 mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="form-check">
                  <input
                    value="Card"
                    checked={paymentMethod === "Card"}
                    onChange={handleChange}
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    {" "}
                    Credit / Debit Card
                  </label>
                </div>
                <div className="d-flex">
                  <img src={card} alt="" className="payment-method-img" />
                </div>
              </div>

              {paymentMethod === "Card" && user.user_type === "cashier" && (
                <div className="mt-1 payment-card">
                  <div className="row">
                    <div className="p-2  mb-2 d-flex gap-2 ms-1">
                      <div className="radio-container">
                        <div className="d-flex">
                          <input
                            type="radio"
                            name="visa"
                            value="Visa Card"
                            id="visa"
                            checked={cardType === "Visa Card"}
                            onChange={handleCartChange}
                          />
                          <label className="pt-1 ps-2" htmlFor="Visa Card">
                            Visa
                          </label>
                        </div>
                      </div>

                      <div className="radio-container">
                        <div className="d-flex">
                          <input
                            type="radio"
                            name="MasterCard"
                            value="Master Card"
                            id="MasterCard"
                            checked={cardType === "Master Card"}
                            onChange={handleCartChange}
                          />
                          <label className="pt-1 ps-2" htmlFor="Master Card">
                            Master Card
                          </label>
                        </div>
                      </div>

                      <div className="radio-container">
                        <div className="d-flex">
                          <input
                            type="radio"
                            name="AmericanExpress"
                            value="American Express"
                            id="AmericanExpress"
                            checked={cardType === "American Express"}
                            onChange={handleCartChange}
                          />
                          <label
                            className="pt-1 ps-2"
                            htmlFor="American Express"
                          >
                            American Express
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-5 ">
                      <label>{cardType} No.</label>
                    </div>
                    <div className="col-7 ">
                      <input
                        type="number"
                        min="11"
                        max="13"
                        onChange={handleDigitalNumber}
                        className="form-control form-control-sm"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Digital payment  */}
            <div className="border rounded p-1 mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="form-check">
                  <input
                    value="Digital Payment"
                    checked={paymentMethod === "Digital Payment"}
                    onChange={handleChange}
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    {" "}
                    Digital Payment
                  </label>
                </div>
                <div className="d-flex">
                  <div className="d-flex gap-2 w-75">
                    <img
                      style={{ padding: "0 0 2px 0", height: "20px" }}
                      src={rocket}
                      alt=""
                      className="payment-method-img border-bottom-3 border-primary w-100 "
                    />
                    <img
                      style={{ padding: "0 0 2px 0", height: "20px" }}
                      src={nagad}
                      alt=""
                      className="payment-method-img border-bottom-3 border-primary w-100 "
                    />
                    <img
                      style={{ padding: "0 0 2px 0", height: "20px" }}
                      src={bkash}
                      alt=""
                      className="payment-method-img border-bottom-3 border-primary w-100 "
                    />
                  </div>
                </div>
              </div>
              {paymentMethod === "Digital Payment" &&
                user.user_type === "cashier" && (
                  <div className="mt-1 payment-digital">
                    <div className="row">
                      <div className="p-2  mb-2 d-flex gap-2 ms-1">
                        <div className="radio-container">
                          <div className="d-flex">
                            <input
                              type="radio"
                              name="R"
                              value="R"
                              id="rocket"
                              checked={digitalType === "R"}
                              onChange={handleDigitalChange}
                            />
                            <label className="pt-1 ps-2" htmlFor="rocket">
                              Rocket
                            </label>
                          </div>
                        </div>

                        <div className="radio-container">
                          <div className="d-flex">
                            <input
                              type="radio"
                              name="N"
                              value="N"
                              id="nagad"
                              checked={digitalType === "N"}
                              onChange={handleDigitalChange}
                            />
                            <label className="pt-1 ps-2" htmlFor="nagad">
                              Nagad
                            </label>
                          </div>
                        </div>

                        <div className="radio-container">
                          <div className="d-flex">
                            <input
                              type="radio"
                              name="B"
                              value="B"
                              id="bkash"
                              checked={digitalType === "B"}
                              onChange={handleDigitalChange}
                            />
                            <label className="pt-1 ps-2" htmlFor="bkash">
                              Bkash
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row ">
                      <div className="col-5 ">
                        <label>{digitalType} No.</label>
                      </div>
                      <div className="col-7 ">
                        <input
                          type="number"
                          min="11"
                          max="13"
                          onChange={handleDigitalNumber}
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>

          <hr className="my-2" />
          <div className="pos-invoice-preview">
            <h6 className="pos-right-heading fw-bold mb-2">Invoice Preview</h6>
            <div className="pos-invoice-content mt-2 p-3">
              <div className="d-flex justify-content-between align-items-center mt-1">
                <span className="invoice-sub-item">Total</span>
                <span className="invoice-item-price">
                  {invoiceAllTotal > 0 ? parseFloat(invoiceAllTotal).toFixed(2) : "0.00"}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-1">
                <span className="invoice-sub-item">Max Discountable</span>
                <span className="invoice-item-price">
                  {maximumDiscountableAmount > 0 ? parseFloat(maximumDiscountableAmount).toFixed(2) : "0.00"}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-1">
                <span className="invoice-sub-item">Discount</span>
                <span className="invoice-item-price">
                  {specialDiscount > 0 ? parseFloat(specialDiscount).toFixed(2) : "0.00"}
                </span>
              </div>
              {selectedInvoice?.special_discount ? (
                <></>
              ) : (
                <div
                  className="special-discount-container d-flex justify-content-between align-items-center mt-1 "
                  style={{
                    background: "#fff",
                    borderRadius: "4px",
                    padding: "3px 3px 3px 12px",
                  }}
                >
                  <div className="d-flex gap-3">
                    <div className="d-flex align-items-center gap-1">
                      <input
                        onChange={() => {
                          setSpecialDiscountType("Fixed");
                          setSpecialDiscount("");
                          setDiscountError(false);
                        }}
                        disabled={
                          invoiceAllTotal === 0 ||
                          maximumDiscountableAmount === 0
                        }
                        readOnly={
                          invoiceAllTotal === 0 ||
                          maximumDiscountableAmount === 0
                        }
                        type="radio"
                        defaultChecked={specialDiscountType === "Fixed"}
                        name="disc"
                        id="disc_fixed"
                      />
                      <label htmlFor="disc_fixed">Fixed</label>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <input
                        onChange={() => {
                          setSpecialDiscountType("Percentage");
                          setSpecialDiscount("");
                          setDiscountError(false);
                        }}
                        disabled={
                          invoiceAllTotal === 0 ||
                          maximumDiscountableAmount === 0
                        }
                        readOnly={
                          invoiceAllTotal === 0 ||
                          maximumDiscountableAmount === 0
                        }
                        type="radio"
                        name="disc"
                        id="disc_percent"
                      />
                      <label htmlFor="disc_percent">Percentage</label>
                    </div>
                  </div>
                  <div style={{ width: "100px" }}>
                    <input
                      type="number"
                      onChange={(e) => handleSpecialPercentage(e)}
                      min={
                        specialDiscountType === "Percentage" ? "1" : undefined
                      }
                      disabled={
                        invoiceAllTotal === 0 || maximumDiscountableAmount === 0
                      }
                      readOnly={
                        invoiceAllTotal === 0 || maximumDiscountableAmount === 0
                      }
                      max={
                        specialDiscountType === "Percentage" ? "100" : undefined
                      }
                      className={`form-control form-control-sm text-end ${discountError ? "is-invalid" : ""}`}
                      style={
                        discountError
                          ? {
                            borderColor: "#dc3545",
                            boxShadow: "0 0 0 0.15rem rgba(220,53,69,.25)",
                          }
                          : {}
                      }
                    />
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-between align-items-center mt-1">
                <span className="invoice-sub-item">VAT/TAX</span>
                <span className="invoice-item-price">0</span>
              </div>
              {partialInvoice ? (
                <>
                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <span className="invoice-sub-item">Paid</span>
                    <span className="invoice-item-price">
                      {selectedInvoice?.paid_amount > 0
                        ? selectedInvoice?.paid_amount
                        : "0.00"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-2 pt-2 invoice-total">
                    <h6 className="fw-bolder mb-0">Due</h6>
                    <span className="fw-bold">
                      {grandTotal > 0 ? grandTotal : "0.00"}
                    </span>
                  </div>
                </>
              ) : (
                <div className="d-flex justify-content-between align-items-center mt-2 pt-2 invoice-total">
                  <h6 className="fw-bolder mb-0">Grand Total</h6>
                  <span className="fw-bold">
                    {grandTotal > 0 ? grandTotal : "0.00"}
                  </span>
                </div>
              )}
            </div>
          </div>

          <hr className="my-2" />
          <div className="pos-invoice-cash">
            {selectedInvoice?.payment_status === "Partially Paid" ? (
              <></>
            ) : (
              <div className="d-flex justify-content-between align-items-center">
                <h6 className="pos-right-heading fw-bold mb-0">
                  Cash Collection
                </h6>
                <div className="d-flex">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="Credit Payment"
                    id="credit_payment"
                    onChange={handleChange}
                    disabled={paymentMethod === "Credit Payment"}
                  />
                  <label className="pt-1 ps-2" htmlFor="credit_payment">
                    Credit Payment
                  </label>
                </div>
              </div>
            )}

            <div className="pos-invoice-cash-content mt-2 p-3">
              <div className="d-flex justify-content-between align-items-center mt-1">
                <span className="invoice-sub-item fw-500">Grand Total:</span>
                <div className="d-flex align-items-center gap-1">
                  {grandTotal > 0 && (
                    <FaAngleDown
                      title="Click to set grand total as paid amount"
                      onClick={() =>
                        handlePay({
                          target: {
                            value: parseFloat(grandTotal).toFixed(2),
                          },
                        })
                      }
                      size={18}
                      className="text-primary"
                      style={{ cursor: "pointer" }}
                    />
                  )}
                  <span className="invoice-item-price">
                    {grandTotal > 0
                      ? parseFloat(grandTotal).toFixed(2)
                      : "0.00"}
                  </span>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-2">
                <span className="invoice-sub-item fw-500">Paid Amount:</span>
                <input
                  onChange={(e) => handlePay(e)}
                  type="number"
                  value={paidAmount}
                  className={`form-control form-control-sm text-end ${paidAmountError ? "is-invalid" : ""}`}
                  style={{
                    width: "150px",
                    ...(paidAmountError
                      ? {
                        borderColor: "#dc3545",
                        boxShadow: "0 0 0 0.15rem rgba(220,53,69,.25)",
                      }
                      : {}),
                  }}
                />
              </div>
              <div className="d-flex justify-content-between align-items-center mt-2">
                <span className="invoice-sub-item fw-500">Return Amount:</span>
                <span className="invoice-item-price">
                  {parseFloat(returnAmount).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={closePaymentModal}
            className="custom-btn-outline px-4"
          >
            Cancel
          </button>
          {paidAmount > 0 ||
            paymentMethod === "Credit Payment" ||
            grandTotal == "0.00" ? (
            <button
              disabled={loading}
              onClick={handleUpdate}
              className="custom-btn px-4"
            >
              {loading ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                "Payment"
              )}
            </button>
          ) : (
            <button
              onClick={() => toast.error("You need to pay first")}
              title={"You need to pay first"}
              className="custom-btn-disabled px-4"
            >
              Pay First
            </button>
          )}
          <button
            onClick={() => {
              setIsPreview(true);
              setTimeout(() => {
                handlePrintPreview();
                setIsPreview(false);
              }, 100);
            }}
            className="custom-btn px-4"
          >
            Preview
          </button>
        </Modal.Footer>
      </Modal>
      <div ref={componentRef} className="sales-invoice">
        <Invoice
          isSpecialDiscount={isSpecialDiscount}
          invoice={invoice}
          salesDicount="0.00"
          grandTotal={grandTotal}
          paidAmount={paidAmount}
          returnAmount={returnAmount}
          specialDiscount={specialDiscount}
          specialDiscountType={specialDiscountType}
          specialDiscountPercent={specialDiscountPercent}
          currentMember={currentMember}
          isPreview={isPreview}
        />
      </div>
    </div>
  );
};

export default RightSidebar;
